
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";

import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
const PatientVitalsV2 = React.lazy(() => import("../../pages/RpmModule/Components/PatientDetails/Components/Patient Vitals V2/PatientVitalsV2"));
const PersonalHealthCare = React.lazy(() => import("../../components/RpmModule/Components/PatientDetails/Components/PersonalHealthCare/PersonalHealthCare"));
const ConsultationHistory = React.lazy(() => import("../../pages/RpmModule/Components/PatientDetails/Components/Consultation History/ConsultationHistory"));
const RpmProfile = React.lazy(() => import("../../components/RpmModule/Components/PatientDetails/Components/RpmProfileold/RpmProfile"));
const Settings = React.lazy(() => import("../../pages/RpmModule/Components/PatientDetails/Components//SettingsComponent/SettingsComponent"));
const AuditLog = React.lazy(() => import("../../pages/RpmModule/Components/AuditLog/AuditLog"));

const ActionRequired = React.lazy(() => import("../../pages/RpmModule/Components/Other Components/ActionRequired"));
const DoctorActionRequired = React.lazy(() => import("../../pages/RpmModule/Components/Other Components/DoctorAction"));



function PatientDetailsRoute() {


    let { path, url } = useRouteMatch();
    let reduxvitalsdata = useSelector((state) => state);
    let userId = reduxvitalsdata.login.user.userId;
    let userType = reduxvitalsdata.login.user.userType;

    let [isAction,setIsAction]=useState(false);

    


    return (
        <Switch>
            
            {/* <Route
                exact
                path={`${path}/patientvitals`}
                component={PatientVitalsV2}
            /> */}

            <Route
                path={`${path}/healthrecords`}
                component={PersonalHealthCare}
            />

            {/* <Route
                path={`${path}/consultationhistory`}
                component={ConsultationHistory}
            /> */}


            <Route
                path={`${path}/profile`}
                component={RpmProfile}
            />

            {/* <Route
                path={`${path}/settings`}
                component={Settings}
            />

            <Route
                path={`${path}/auditlog`}
                component={AuditLog}
            /> */}



        </Switch>
    )
}

export default PatientDetailsRoute